import { addPhoneLogEntry } from 'flow/utils/browser-utils';
// The following rows overrides the default console.warn behaviour.
// This is to enable JsSIP:ERROR logging to out internal logging
console.stdwarn = console.warn.bind(console); // eslint-disable-line no-console
console.warn = function () {
    const argumentArray = [...arguments].filter(
        (o) => o && !o.toString().includes('color: '),
    );
    if (
        argumentArray &&
        argumentArray[0] &&
        argumentArray[0].toString().includes('JsSIP:ERROR')
    ) {
        // Remove all color-coding in errors
        const argumentMessage =
            argumentArray && argumentArray.shift().replace(/%c/g, '');

        const replaceStr = (string, ...placeholders) => {
            let count = 0;
            return string.replace(/%o/g, () => placeholders[count++]);
        };

        const logMessage = replaceStr(argumentMessage, argumentArray);
        addPhoneLogEntry(logMessage);
    }
    // eslint-disable-next-line no-console
    console.stdwarn.apply(console, arguments);
};

// jssip's Logger class binds its debug output to console.info at module load
// (this._debug.log = console.info.bind(console)), so like JsSIP:ERROR above,
// SIP transport messages can only be captured by wrapping console.info before
// jssip is imported — which is why this lives here and not in phone-actions.
// addLogEntry never console.infos PHONE entries, so this cannot recurse.
console.stdinfo = console.info.bind(console); // eslint-disable-line no-console
console.info = function (...args) {
    if (typeof args[0] === 'string' && args[0].includes('JsSIP:')) {
        addPhoneLogEntry(args[0].replace(/%c/g, ''));
    }
    // eslint-disable-next-line no-console
    console.stdinfo.apply(console, args);
};
